export default {
      id: "burger-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#burger",
      toString: function () {
        return this.url;
      }
    }